export const StepsStatusEnum = {
  PRIVATE: 'PRIVATE',
  PUBLIC: 'PUBLIC',
  SENDABLE: 'SENDABLE'
} as const;

export type StepsStatusEnum = typeof StepsStatusEnum[keyof typeof StepsStatusEnum];

export const StepsTypeEnum = {
  DEFAULT: 'DEFAULT',
  FIXED: 'FIXED'
} as const;

export type StepsTypeEnum = typeof StepsTypeEnum[keyof typeof StepsTypeEnum];

export const ChannelEnum = {
  EMAIL: 'EMAIL',
  DRIVER_APP: 'DRIVER_APP',
  SMS: 'SMS',
  WHATSAPP: 'WHATSAPP',
  // @deprecated: to remove when all references to this value will be removed
  INTEGRATION: 'INTEGRATION'
} as const;

export type ChannelEnum = typeof ChannelEnum[keyof typeof ChannelEnum];

export const KanbanColumnEnum = {
  IN_HOUSE: 'IN_HOUSE',
  CHECK_OUT_READY: 'CHECK_OUT_READY',
  CHECK_OUT_COMPLETED: 'CHECK_OUT_COMPLETED'
} as const;

export type KanbanColumnEnum = typeof KanbanColumnEnum[keyof typeof KanbanColumnEnum];

export const TriggerTypeEnum = {
  SCHEDULE: 'SCHEDULE'
} as const;

export type TriggerTypeEnum = (typeof TriggerTypeEnum)[keyof typeof TriggerTypeEnum];

export const StepsCodeEnum = {
  FOLLOW_UP: 'FOLLOW_UP',
  PLANNED: 'PLANNED',
  READY: 'READY',
  REMINDED: 'REMINDED'
} as const;

export type StepsCodeEnum = (typeof StepsCodeEnum)[keyof typeof StepsCodeEnum];
